module.exports = __webpack_public_path__ + "static/media/twitter.52686040.png";